export const YEEKEE = 1
export const YEEKEE_SPEED = 17
export const YEEKEE_RICHSABET = 12
export const YEEKEE_SET = 10
export const YEEKEE_TEN_MIN = 19

export const HUAY_FAH = 15
export const HUAY_FAH_VIP = 16
export const HUAY_FAH_FIVE_MIN = 24

export const YEEKEE_LTO = 27
export const YEEKEE_LTO_VIP = 28
export const YEEKEE_LTO_FIVE_MIN = 29
export const YEEKEE_LTO_FIVE_MIN_VIP = 30
const POWER_BALL = 22
const PG_SLOT = 26
const CASINO_SA_GAMING = 6
const BTI_FOOTBALL = 31
const BET_WORLD = 32
const SBO_FOOTBALL = 21
const CASINO_CHERRY = 33
//map total equal image => ./assets/externalgame/*.svg
export const EXTERNALGAME = [
  5, 7, 8, 13, 14, 18,
  SBO_FOOTBALL,
  POWER_BALL,
  CASINO_SA_GAMING,
  PG_SLOT,
  BTI_FOOTBALL,
  CASINO_CHERRY
]

//use for sum in affiliate page (HARDCODE !!)
export const CASINO_TYPE = [5, 7, 13, 18, CASINO_SA_GAMING, CASINO_CHERRY]


export const LOTTO = 2
export const LOTTO_VIP = 20
export const LOTTO_SPECIAL_PRICE = 23
export const THAI_LOTTO_AFFILIATE = 25
export const THAI_LOTTO = 3
export const FOREIGN_LOTTO = 11
export const GROUPNUMBER = 4

export const ALL_YEEKEE_TYPE = [
  YEEKEE,
  // YEEKEE_SET,
  // YEEKEE_SPEED,
  // YEEKEE_RICHSABET,
  // YEEKEE_TEN_MIN,
  // HUAY_FAH,
  // HUAY_FAH_VIP,
  // HUAY_FAH_FIVE_MIN,
  // YEEKEE_LTO,
  // YEEKEE_LTO_VIP,
  // YEEKEE_LTO_FIVE_MIN,
  // YEEKEE_LTO_FIVE_MIN_VIP
]
export const LOTTO_GAME_TYPE = [
  LOTTO,
  THAI_LOTTO,
  LOTTO_VIP,
  LOTTO_SPECIAL_PRICE,
  GROUPNUMBER,
  FOREIGN_LOTTO,
].concat(ALL_YEEKEE_TYPE)

export const IsGameCanUserVoucher = (id) => {
  return [YEEKEE, YEEKEE_SET, YEEKEE_SPEED, YEEKEE_TEN_MIN].includes(id)
}

export const IsYeekeeType = (id) => {
  return ALL_YEEKEE_TYPE.includes(id)
}

export const CARD_FOUR_COLUMN = [
  LOTTO,
  LOTTO_VIP,
  LOTTO_SPECIAL_PRICE
]

export const CARD_TWO_COLUMN = [
  HUAY_FAH,
  HUAY_FAH_VIP,
  HUAY_FAH_FIVE_MIN,
  THAI_LOTTO,
  FOREIGN_LOTTO
]
export const CARD_ONE_COLUMN = [
  GROUPNUMBER
]

export const classCardColor = (id) => {
  switch (id) {
    case YEEKEE_RICHSABET:
      return 'YeekeeGroup'
    case HUAY_FAH:
      return 'HuayFah'
    case THAI_LOTTO:
      return 'ThaiStock'
    case THAI_LOTTO_AFFILIATE:
      return 'ThaiStock'
    case LOTTO_VIP:
      return 'ThaiVIPStock'
    case LOTTO:
      return 'Stock'
    case FOREIGN_LOTTO:
      return 'ForiegnStock'
    case YEEKEE:
      return 'YeekeeStock'
    case YEEKEE_SET:
      return 'YeekeeStock'
    case YEEKEE_SPEED:
      return 'YeekeeSpeed'
    case GROUPNUMBER:
      return 'ListStock'
    case HUAY_FAH_VIP:
      return 'HuayFahVip'
    case YEEKEE_TEN_MIN:
      return 'Yeekeeten'
    case LOTTO_SPECIAL_PRICE:
      return 'ThaiSpecialPriceStock'
    case HUAY_FAH_FIVE_MIN:
      return 'HuayFahFiveMin'
    default:
      return 'DefaultStock'
  }
}
export const isGameTypeIdSeamless = (id) => {
  return [BET_WORLD].includes(id)
}